import Training from '../components/trainingpage/Training';

const TrainingPage = () => {
    return (
        <>
            <Training />
        </>
    );
};

export default TrainingPage;
